module.exports = __webpack_public_path__ + "img/Sales Forecasting.db4d46f6.jpg";